import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { RefreshCw, Upload, Trash2 } from 'lucide-react';
import api from '../../services/api';
import Badge from '../../components/shared/Badge';

export default function PortaisSync() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ['portais-status'],
    queryFn: () => api.get('/portais/status').then(r => r.data.data || []),
  });

  const syncAll = useMutation({
    mutationFn: () => api.post('/portais/sync-all'),
    onSuccess: () => { qc.invalidateQueries(['portais-status']); alert('Sincronização iniciada!'); },
  });

  const remover = useMutation({
    mutationFn: (uid) => api.delete(`/portais/remover/${uid}`),
    onSuccess: () => qc.invalidateQueries(['portais-status']),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Portais Imobiliários</h1>
        <button onClick={() => syncAll.mutate()} disabled={syncAll.isPending}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg text-sm hover:bg-secondary disabled:opacity-50">
          <RefreshCw size={16} className={syncAll.isPending ? 'animate-spin' : ''} />
          Sincronizar Tudo
        </button>
      </div>
      <div className="bg-white rounded-xl shadow overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center text-gray-400">Carregando...</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-xs uppercase">
              <tr>
                <th className="px-6 py-3 text-left">Portal</th>
                <th className="px-6 py-3 text-left">Empreendimento</th>
                <th className="px-6 py-3 text-left">Unidade</th>
                <th className="px-6 py-3 text-left">Status</th>
                <th className="px-6 py-3 text-left">Último sync</th>
                <th className="px-6 py-3 text-left">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {(data || []).map(item => (
                <tr key={item.id}>
                  <td className="px-6 py-4 capitalize font-medium">{item.portal?.replace(/_/g, ' ')}</td>
                  <td className="px-6 py-4 text-gray-600">{item.empreendimento_nome}</td>
                  <td className="px-6 py-4 text-gray-600">{item.identificador} {item.torre}</td>
                  <td className="px-6 py-4"><Badge label={item.status} variant={item.status} /></td>
                  <td className="px-6 py-4 text-gray-400 text-xs">{item.ultimo_sync ? new Date(item.ultimo_sync).toLocaleString('pt-BR') : '—'}</td>
                  <td className="px-6 py-4">
                    <button onClick={() => remover.mutate(item.unidade_id)} className="text-danger hover:text-red-700">
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
              {!data?.length && <tr><td colSpan={6} className="px-6 py-8 text-center text-gray-400">Nenhuma publicação ativa</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
